import { render, staticRenderFns } from "./ChatOrderBySelector.vue?vue&type=template&id=0c9ae239&scoped=true&"
import script from "./ChatOrderBySelector.vue?vue&type=script&lang=js&"
export * from "./ChatOrderBySelector.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderBySelector.vue?vue&type=style&index=0&id=0c9ae239&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9ae239",
  null
  
)

export default component.exports